module.exports = __webpack_public_path__ + "assets/img/37_722.129f5846.jpg";